export default __webpack_public_path__ + "static/media/1_1_1.7054ebb3.png";